/*  ========================================================================
    # Hooks - Use SVG Sprite
    ========================================================================  */

/**
 * Hook to get the SVG sprite.
 */
const useSVGSprite = () => {
  return (window as Window & { svgSprite?: string }).svgSprite || '';
};

export default useSVGSprite;
